import { round } from 'lodash-es';
import { Container, Point } from 'pixi.js-legacy';
import Constants from '../constants';
import { ScalableTextManager, ScalableTextOptions } from '../managers';
import ViewStyle from '../viewStyle';
export class TierOptions {
    constructor() {
        this.id = '';
        this.number = 0;
        this.xDim = 0;
        this.yDim = 0;
        this.viewStyle = ViewStyle.Diagram;
    }
}
export class Tier extends Container {
    constructor(options = new TierOptions()) {
        super();
        this.beams = new Container();
        this.columns = new Container();
        this.joists = new Container();
        this.cutouts = new Container();
        this.decking = new Container();
        this.dimensions = new Container();
        this.marks = new Container();
        this.polylines = new Container();
        this.foreground = new Container();
        this.angles = new Container();
        this.name = 'Tier';
        this.id = options.id;
        this.number = options.number;
        this.scaledXDim = options.xDim;
        this.scaledYDim = options.yDim;
        this.addChild(this.decking);
        this.addChild(this.polylines);
        this.addChild(this.cutouts);
        this.addChild(this.joists);
        this.addChild(this.beams);
        this.addChild(this.angles);
        this.addChild(this.columns);
        this.addChild(this.marks);
        this.addChild(this.dimensions);
        this.addChild(this.foreground);
        this.createXDimText();
        this.createYDimText();
        this.createTierNumberText();
        if (options.viewStyle === ViewStyle.Diagram) {
            this.diagramMode();
        }
        else {
            this.designMode();
        }
    }
    diagramMode() {
        this.joists.visible = false;
        this.marks.visible = false;
        for (const column of this.columns.children) {
            column.diagramMode();
        }
        for (const beam of this.beams.children) {
            beam.diagramMode();
        }
    }
    designMode() {
        this.joists.visible = true;
        this.marks.visible = true;
        for (const column of this.columns.children) {
            column.designMode();
        }
        for (const beam of this.beams.children) {
            beam.designMode();
        }
    }
    createXDimText() {
        const options = new ScalableTextOptions();
        options.text =
            round(this.scaledXDim / Constants.scalingFactor, 3) + 'm (x dim)';
        options.x = this.scaledXDim / 2;
        options.y = -15 - Constants.polylineWidth;
        options.anchor = new Point(0.5, 0.5);
        options.size = 40;
        ScalableTextManager.getInstance().createText(this.dimensions, options);
    }
    createYDimText() {
        const options = new ScalableTextOptions();
        options.text =
            round(this.scaledYDim / Constants.scalingFactor, 3) + 'm (y dim)';
        options.x = -15 - Constants.polylineWidth;
        options.y = this.scaledYDim / 2;
        options.anchor = new Point(0.5, 0.5);
        options.rotation = 4.71239;
        options.size = 40;
        ScalableTextManager.getInstance().createText(this.dimensions, options);
    }
    createTierNumberText() {
        const options = new ScalableTextOptions();
        options.text = `Tier: ${this.number}`;
        options.x = this.scaledXDim / 2;
        options.y = this.scaledYDim + 40 + Constants.polylineWidth;
        options.anchor = new Point(0.5, 0.5);
        options.size = 40;
        ScalableTextManager.getInstance().createText(this.dimensions, options);
    }
    addAngle(angle) {
        this.angles.addChild(angle);
    }
    addPolyline(polyline) {
        this.polylines.addChild(polyline);
    }
    addDecking(decking) {
        this.decking.addChild(decking);
    }
    addBeam(beam) {
        this.beams.addChild(beam);
    }
    addColumn(column) {
        this.columns.addChild(column);
    }
    addJoist(joist) {
        this.joists.addChild(joist);
    }
    addCutout(cutout) {
        this.cutouts.addChild(cutout);
        cutout.checkCollisionsAndSnapToOthers();
    }
    removeCutout(id) {
        const cutoutToRemove = this.cutouts.children.find((c) => c.id === id);
        if (cutoutToRemove) {
            this.cutouts.removeChild(cutoutToRemove);
            cutoutToRemove.destroy();
        }
    }
    setCutoutSnapping(val) {
        for (const cutout of this.cutouts.children) {
            cutout.allowCutoutSnapping = val;
        }
    }
    setEdgeSnapping(val) {
        for (const cutout of this.cutouts.children) {
            cutout.allowEdgeSnapping = val;
        }
    }
    setCutoutCollision(val) {
        for (const cutout of this.cutouts.children) {
            cutout.allowCollision = val;
        }
    }
    setRenderCutoutOutline(val) {
        for (const cutout of this.cutouts.children) {
            cutout.setShouldRenderOutline(val);
        }
    }
}
